import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';
import marked from 'marked';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import { useIntl } from 'react-intl';

const linkRenderer = new marked.Renderer();

linkRenderer.link = (href, title, text) =>
{
	title = title ? title : href;
	text = text ? text : href;

	return `<a target='_blank' href='${ href }' title='${ title }'>${ text }</a>`;

};

marked.setOptions({ breaks: true });

const styles = (theme) =>
	({
		root :
		{
			display      : 'flex',
			marginBottom : theme.spacing(1),
			padding      : '3%',
			flexShrink   : 0,
			width        : '100%'
		},
		selfMessage :
		{
			marginLeft      : 'auto',
			backgroundColor : '#9ec317',
			color           : 'white'
		},
		remoteMessage :
		{
			marginRight : 'auto'
		},
		text :
		{
			fontSize  : '0.8rem',
			width     : '100%',
			wordBreak : 'break-all !important',
			'& p'     :
			{
				margin : 0
			}
		},
		content :
		{
			marginLeft : theme.spacing(1),
			textAlign  : 'left'
		},
		avatar :
		{
			borderRadius    : '50%',
			height          : '2rem',
			alignSelf       : 'center',
			backgroundColor : '#fff',
			aspectRatio     : 1
		},
		downloadLink :
		{
			cursor     : 'pointer',
			'& > span' : {
				textDecoration : 'underline'
			}
		},
		speaker :
		{
			display    : 'block',
			lineHeight : '1rem',
			textAlign  : 'start'
		}
	});

const Message = (props) =>
{
	// const intl = useIntl();

	const {
		self,
		type,
		// picture,
		text,
		fileName,
		fileShareUrl,
		error,
		// time,
		name,
		classes,
		isHost
	} = props;

	const icon = isHost ?
		self ? 'images/icon_host_chatHost.svg' : 'images/icon_host_chatGuest.svg'
		:
		self ? 'images/icon_guest_chatGuest.svg' : 'images/icon_guest_chatHost.svg';

	let fileShareText = '';

	if (type === 'file' && fileShareUrl && !error)
	{
		fileShareText = `共有ファイル: <span>${fileName}</span>`;
	}
	// file share failed
	else if (type === 'file' && self && (error || !fileShareUrl))
	{
		fileShareText = `${fileName}の共有に失敗しました。`;
	}

	const downloadFile = (fName, url) =>
	{
		if (url)
		{
			try
			{
				const xhr = new XMLHttpRequest();

				xhr.responseType = 'blob';

				xhr.onload = function()
				{

					const link = document.createElement('a');

					// create new Blob to remove type data
					const blob = new Blob([ xhr.response ]);

					// get URL of blob data
					const blobUrl = window.URL.createObjectURL(blob);

					link.download = fName;

					// set href
					link.setAttribute('href', blobUrl);

					// download file
					link.click();

					// free memory
					window.URL.revokeObjectURL(blobUrl);

					link.remove();
				};

				const downloadURL = url;

				xhr.open('GET', downloadURL);
				xhr.send();
			}
			catch
			{
				// do nothing
			}
		}
	};

	return (
		<Paper
			className={classnames(
				classes.root,
				self ? classes.selfMessage : classes.remoteMessage
			)}
		>
			<img alt='Avatar' className={classes.avatar} src={icon} />
			<div className={classes.content}>
				{
					self ?
						null
						: !isHost ?
							<Typography variant='caption' className={classes.speaker}>
								{name}
							</Typography>
							:
							<Typography variant='caption' className={classes.speaker}>
								お客様
							</Typography>
				}

				{ type === 'file' ?
					<Typography
						className={`${classes.text} ${classes.downloadLink}`}
						variant='body1'
						onClick={() => downloadFile(fileName, fileShareUrl)}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html : DOMPurify.sanitize(
							fileShareText
						) }}
					/>
					:

					<Typography
						className={classes.text}
						variant='body1'
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html : DOMPurify.sanitize(
							marked.parse(
								text,
								{ renderer: linkRenderer }
							),
							{
								ALLOWED_TAGS : [ 'a', 'br' ],
								ALLOWED_ATTR : [ 'href', 'target', 'title' ]
							}
						) }}
					/>
				}

			</div>
		</Paper>
	);
};

Message.propTypes =
{
	self         : PropTypes.bool,
	type         : PropTypes.string,
	picture      : PropTypes.string,
	text         : PropTypes.string,
	fileName     : PropTypes.string,
	fileShareUrl : PropTypes.string,
	error        : PropTypes.bool,
	time         : PropTypes.object,
	name         : PropTypes.string,
	classes      : PropTypes.object.isRequired,
	isHost       : PropTypes.bool
};

export default withStyles(styles)(Message);